package org.braunequip.web.pages.braunadmin

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import org.braunequip.web.components.layouts.AdminPageLayout
import org.braunequip.web.components.sections.AdminTables.AdminContactsTable
import org.braunequip.web.components.sections.AdminTables.AdminDieselLogsTable
import org.braunequip.web.components.sections.AdminTables.AdminEquipmentRepairsTable
import org.braunequip.web.components.sections.AdminTables.AdminTimeOffTable
import org.braunequip.web.util.Routes.Admin.FRONT_FORMS_ROUTE
import org.braunequip.web.util.Theme
import org.braunequip.web.util.isUserLoggedIn
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*

@Page
@Composable
fun AdminHomePage() {
    isUserLoggedIn {
        AdminPageLayout {
            AdminHomeScreen()
        }
    }
}

@Composable
fun AdminHomeScreen() {
    val context = rememberPageContext()
    val refreshedTab = remember(key1 = context.route) { context.route.params["tab"] ?: ""}

    Section(
        attrs = Modifier
            .padding(16.px)
            .fillMaxSize()
            .display(DisplayStyle.Flex)
            .flexDirection(FlexDirection.Column)
            .toAttrs()
    ) {
        AdminFormTabs(
            tabs = listOf(
                "Contact Forms",
                "Time Off Requests",
                "Diesel Fuel Logs",
                "Equipment Repairs"
            ),
            tabViewStyle = Modifier
                .fillMaxSize(),
            contentBlocks = listOf(
                { AdminContactsTable() },
                { AdminTimeOffTable() },
                { AdminDieselLogsTable() },
                { AdminEquipmentRepairsTable() }
            ),
            refreshedTab = refreshedTab,
            onSelectedTab = { tabIndex ->
                context.router.navigateTo("${FRONT_FORMS_ROUTE}?tab=$tabIndex")
            }
        )
    }
}

@Composable
fun AdminFormTabs(
    tabs: List<String>,
    tabViewStyle: Modifier = Modifier,
    contentBlocks: List<@Composable () -> Unit>,
    refreshedTab: String,
    onSelectedTab: (Int) -> Unit,
) {
    var activeTab by remember { mutableStateOf(refreshedTab.toIntOrNull() ?: 0) }

    Div(
        attrs = Modifier
            .padding(top = 5.px)
            .margin(0.px)
            .classNames("tabs", "is-boxed")
            .toAttrs()
    ) {
        Ul(
            attrs = Modifier
                .toAttrs()
        ) {
            tabs.forEachIndexed { index, tab ->
                Li(
                    attrs = Modifier
                        .classNames(if (activeTab == index) "is-active" else "has-dark-text")
                        .color(if (activeTab == index) Theme.Primary.rgb else Colors.Grey)
                        .onClick {
                            activeTab = index
                            onSelectedTab(index)
                        }
                        .toAttrs()
                ) {
                    A {
                        Text(tab)
                    }
                }
            }

        }
    }

    Column(
        modifier = tabViewStyle
    ) {
        contentBlocks[activeTab]()
    }
}